// Common utilties

import CfgPopup from "@/assets/cfg/CfgPopup";
import { eventBus } from '@/main';
import store from "@/store/store";


// Display Object to Console Universal Sorted ==========
export function m() {
	const showConsoleMess = store.getters["app/debug"].showConsoleMess;
	if (showConsoleMess) {
		const answers = [];
		for (let arg of arguments) {
			answers.push(breakdown(arg));
		}
		console.log(...answers);
	}
}

const breakdown = (obj) => {
	// console.log("breakdown type", typeof obj);
	let answer = obj;
	if (!!obj && typeof obj == "object") {
		answer = {};
		let keys = Object.keys(obj);
		if (obj.constructor===Array) {
			answer = [];
		} else {
			keys.sort();
		}
		for (let key of keys) {
			answer[key] = breakdown(obj[key]);					
		}
	}
	return answer;
};


// Clear focus and window selection
export const blur = () => {
	document.activeElement.blur();
	if (window.getSelection()) window.getSelection().removeAllRanges();
	if (document.getSelection()) document.getSelection().removeAllRanges();
}

// Replace line feeds with <br /> ==========
export const break2Br = (str1) => {
	const str2 = str1 || "";
	return str2.replace(/(\r\n|\n|\r)/gm,'<br/>');
};


// Sanitize User Input Data
export const sanitizeUserData = (str1) => {
	const pattern = /[^a-z0-9áéíóúñü_ .,'";:?!@#$%\^\&\(\)\*\-\+\=\/\{\}\[\]\s]/gim;
	const str2 = str1.trim().replace(pattern, "");
	return str2;
};


// Convert List to Recordset ==========
export const convert2Recordset = (cols, rows) => {
	m("convert2Recordset");
	let recs = [];
	for (let row of rows) {
		let new_rec = {};
		for (let i=0; i<cols.length; i++) {
			new_rec[cols[i]] = row[i];
		}
		recs.push(new_rec);
	}	

	return recs;
}


// Generate Random Word ==========
export const genWord = (word_len) => {
	const pool = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789"; // skip 'IlOo'
	let word = "";
	for (let i=0; i<word_len; i++) {
		const idx = Math.floor(Math.random() * (pool.length+1) );
		word += pool.substr(idx, 1);
	}
	return word;
}


// Validate Date String & Format ==========
export const valiDateStr = (dateStr) => {

	let d = dateStr;

	if (d.indexOf('.')>=0) {
		const offsetMS = (new Date()).getTimezoneOffset() * 60000;
		d = new Date(Date.now() - offsetMS).toISOString().substring(0,19).replace('T',' ');
	}

	if (d.length==14) {
		d = d.substr(0,4) + '-' + d.substr(4,2) + '-' + d.substr(6,2) + ' ' + d.substr(8,2) + ':' + d.substr(10,2) + ':' + d.substr(12,2);
	}
	if (d.length==12) {
		d = d.substr(0,4) + '-' + d.substr(4,2) + '-' + d.substr(6,2) + ' ' + d.substr(8,2) + ':' + d.substr(10,2) + ':00';
	}
	if (d.length==8) {
		const hr = Math.floor((Math.random() * 23));
		const mn = Math.floor((Math.random() * 59));
		const time = ('0'+hr).slice(-2) + ':' + ('0'+mn).slice(-2) + ':00';
		d = d.substr(0,4) + '-' + d.substr(4,2) + '-' + d.substr(6,2) + ' ' + time;
	}

	var regex		= new RegExp(/^([0-9]{2,4})-([0-1][0-9])-([0-3][0-9])(?:( [0-2][0-9]):([0-5][0-9]):([0-5][0-9]))?$/);

	return {
		ok		: regex.test(d),
		date	: d,
		dateVis: calcVisDate(d)
	};


};


// Visual Format Date ==========
export const calcVisDate = (date_in) => {
	var date_out = 'no date';
	if (date_in.length==19) {
		var month_num = parseInt(date_in.substr(5,2));
		if (month_num > 0 && month_num < 13) {
			var months = ['', 'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			var month_str = months[month_num];
			date_out = month_str + ' ' + date_in.substr(8,2) + ', ' + date_in.substr(0,4) ;

			var hour = parseInt(date_in.substr(11,2));
			if (hour > 0 && hour < 25) {
				var ap = 'am';
				if (hour>=12) ap = 'pm';
				if (hour > 12) hour -=12;
				date_out += ' - ' + hour + date_in.substr(13,3) + ' ' + ap;
			}
		}
	}
	return date_out;
}


// NEW Show Popup Universal Input ==========
export const showPopInput = (colName, value) => {
	m("utils: show popup input", colName);
	let payload = CfgPopup[colName];
	payload.popType = "win";
	payload.compName = payload.compName || "UniInput";
	payload.compData = payload.compData || {}; 
	payload.compData.colName = colName;
	payload.compData.defaultVal = value;
	m("payload", payload);
	eventBus.$emit("popup", payload);			
}




export const showPopMess = (title, type, mess) => {
	m("showPopMess: ", mess);

	let payload = {
		popType: "win",
		popTitle: title,
		compName: "UniMess",
		compData: {
			title: title,
			messType: type,
			mess: mess,
		}
	};
	eventBus.$emit("popup", payload);			

}

export const hidePopup = () => {
	m("hide popup");
	eventBus.$emit("popoff");
};


export const pad = (num, n) => {
	for (var r = num.toString(); r.length < n; r = 0 + r);
	return r;
};

export const getNow = () => {
	const now = new Date();
	const milli = now.getMilliseconds();
	const sec = now.getSeconds();
	const min = now.getMinutes();
	const hou = now.getHours();
	const mo = now.getMonth();
	const dy = now.getDate();
	const yr = now.getFullYear();
	const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	let str = pad(hou,2) + ":" + pad(min,2) + ":" + pad(sec,2) + ":" + pad(milli,3);
	return str;

}





export const getNow2 = () => {
	let timezoneOffset = (new Date()).getTimezoneOffset() * 60000;
	let date = (new Date(Date.now() - timezoneOffset));
	// let a = date.toISOString().substring(0,19).replace('T',' ');
	m("date", date);
	let a = date.toISOString().substring(11,19);
	return a;
}
